import React, { Component } from 'react';
import $ from 'jquery';
import axios from 'axios';
import qs from 'qs';
import PopUp from './functions/popup.js';
import { Link } from "react-router-dom";
import idex from './../../assets/images/idex.svg';
import radar from './../../assets/images/radar.svg';
import ercdex from './../../assets/images/ercdex.svg';
import morph from './../../assets/images/morph.svg';
import './../../css/swapcenter.css';

export default class SwapCenter extends Component {

  render() {

      var data = this.props.data;
      var otp = window.otp;
      var essentiabalance = window.essentiabalance;
      var etherbalance = window.etherbalance;
      var ethprice = window.ethprice;

      axios.defaults.xsrfCookieName = 'csrftoken'
      axios.defaults.xsrfHeaderName = 'X-CSRFToken'

      if (otp === "False") {
        $( document ).ready(function() {
            $("#otp-block").css("display", "none");
        });
      }

      var  getprice = function() {
        // Temporary
        const from_token = "ESS";
        const to_token = "ETH";

        axios.post('/api/idex/price', qs.stringify({
          "from_token": from_token,
          "to_token": to_token,
          "direction": "bids",
        })).then(function (response) {
          $("#swapprice").html(response.data.price);
          var conversion = 0.06 / response.data.price;
          $("#miniconversion").html(conversion.toFixed(8));
        });
      }

      getprice();

      var  getmorphprice = function(from_token, to_token) {

          axios.post('/api/morph/price', qs.stringify({
            "from_token": from_token,
            "to_token": to_token,
          })).then(function (response) {
            $("#swapprice").html(response.data.price);
          });
      }

      var combination = {
        "ESS": 
            {
            "ETH": ["IDEX"], 
            "XYO": ["IDEX"]
            },
        "ETH": 
            {
            "DAI": ["RADAR", "ERCDEX"], 
            "BTC": ["MORPH"],
            "LTC": ["MORPH"],
            }
      } // the inner object has no actual use for now

      var remove_all_active = function(){
        const radar_logo = $("#radar-logo");
        if (radar_logo.hasClass( "active" )){
          radar_logo.removeClass("active");
        }

        const ercdex_logo = $("#ercdex-logo");
        if (ercdex_logo.hasClass( "active" )){
          ercdex_logo.removeClass("active");
        }     

        const idex_logo = $("#idex-logo");
        if (idex_logo.hasClass( "active" )){
          idex_logo.removeClass("active");
        }     

        const morph_logo = $("#morph-logo");
        if (morph_logo.hasClass( "active" )){
          morph_logo.removeClass("active");
        }     
      }

      var get_eth_token_price = function(from_token) {
        // for token to token swap
        const to_token = "ETH";

        axios.post('/api/idex/price', qs.stringify({
          "from_token": from_token,
          "to_token": to_token,
          "direction": "asks",
        })).then(function (response) {
          $("#swapprice2").html(response.data.price);
        });
      }
      var from_token_change = function() {
        var to_token = $("#swap-to").val();
        token_selection_changed(to_token, true);
      }

      var to_token_change = function() {
        var to_token = $("#swap-to").val();
        token_selection_changed(to_token, false);
      }

      var token_selection_changed = function(to_token, change) {
        var from_token = $("#swap-from").val();
        var to_token_options = combination[from_token];
        remove_all_active();

        $("#swap-to").html(""); // clear everything
        if (from_token === "ETH") {
        
          Object.keys(to_token_options).forEach(function(key,index) {
            $("#swap-to").append("<option value='"+ key + "'>" + key + "</option>"); 
          });
          
          // having receiving address
          $("#receiving_address").css("display", "block");
          $("#convert-eth").css("display", "none");

          // make sure this is none
          $("#token-to-token-price").css("display", "none");
          $("#currently-have").html( etherbalance + " ETH");
          $("#miniconversion-unit").html("ETH");

          // TODO: make use of the object to_token_options to select exchanges
          if (change){
            var to_token = $("#swap-to").val();
          }
          if (to_token == "DAI"){
            $("#radar-logo").addClass("active"); 
            $("#swapprice").html(ethprice);
            // opacity rather than display so the space will be reserved
            $("#miniconversion").html("0.05");
          } else if (to_token == "BTC"){ // morph multiasset swap
            $("#swap-to option[value=BTC]").attr('selected', true);
            $("#morph-logo").addClass("active"); 
            $("#miniconversion").html("0.3");
            getmorphprice(from_token, to_token);
          } else if (to_token == "LTC") {
            $("#swap-to option[value=LTC]").attr('selected', true);
            $("#morph-logo").addClass("active"); 
            $("#miniconversion").html("0.3"); 
            getmorphprice(from_token, to_token);
          }
        } else if (from_token === "ESS") {
          $("#idex-logo").addClass("active");

          Object.keys(to_token_options).forEach(function(key,index) {
            $("#swap-to").append("<option value='"+ key + "'>" + key + "</option>"); 
          });
          $("#currently-have").html( essentiabalance + " ESS");
          $("#miniconversion-unit").html("ESS");

          if (change){
            var to_token = $("#swap-to").val();
          }
          if (to_token == "ETH") {
            $("#receiving_address").css("display", "none");  
            $("#convert-eth").css("display", "block");     
            $("#token-to-token-price").css("display", "none");  
            $("#miniconversion").html("0");
          } else {
            $("#receiving_address").css("display", "block");  
            $("#convert-eth").css("display", "none");   
            //Temporary solution
            $("#swap-to option[value=XYO]").attr('selected', true);
            $("#token-to-token-price").css("display", "block");
            get_eth_token_price(from_token);
          }
          $("#swapprice").html("0");
          getprice();
        } else {
          PopUp.prototype.show("Error: \n No exist swap from option");
        }
        estimation();
      }

      var to_ercdex = function() {
        var from_token = $("#swap-from").val();
        var to_token = $("#swap-to").val();
        if (from_token === "ETH" && to_token !== "BTC" && to_token !== "LTC") {
          $("#radar-logo").removeClass("active");
          $("#ercdex-logo").addClass("active");
        }
      }

      var to_radar = function() {
        var from_token = $("#swap-from").val();
        var to_token = $("#swap-to").val();
        if (from_token === "ETH" && to_token !== "BTC" && to_token !== "LTC") {
          $("#radar-logo").addClass("active");
          $("#ercdex-logo").removeClass("active");
        }
      }

      var estimation = function() {
        var amount = $("#amount-swap").val();
        if (amount) {
          var ethrate = parseFloat($("#swapprice").html());
          var eth_estimate = ethrate * parseFloat(amount)

          if ($("#swap-to").val() !== "ETH" && $("#swap-from").val() !== "ETH") {
            var tokenrate = parseFloat($("#swapprice2").html());
            var token_estimate = eth_estimate / tokenrate
            $("#estimated-swap").val(token_estimate.toFixed(10));
          } else {
            $("#estimated-swap").val(eth_estimate.toFixed(10));
          }            

        } else {
          $("#estimated-swap").val("Estimated amount");
        }

      }

      // help facilitate diffferent dex swap
      var swap_request_pattern = function(words, from_token, amount, url) {
        var to_token = $("#swap-to").val();
        var sendTo = $('#receiver').val();
        var otp = $('#otp-sending').val();
        var receiving_address = $('#receiving_address').val();

        if (confirm(words) === true) {
          if (from_token === to_token) {
            PopUp.prototype.show("You can't swap the same token");
          } else {
            var promise;
            promise = axios.post(url, qs.stringify({
              "from_token": from_token,
              "to_token": to_token,
              "amount": amount,
              "sendTo": sendTo,
              "otp": otp,
              "receiving_address": receiving_address,
            }));

            $("#swap-button").html("Swaping");
            $('#swap-button').prop('disabled', true);

            promise.then(function(response){
              console.log(response);

              $("#swap-button").html("Swap");
              $('#swap-button').prop('disabled', false);
              PopUp.prototype.show("Success!\n Check the process in the history page");

            });

            promise.catch(function (error) {
              console.log(error.response.data);
              PopUp.prototype.show("Failed:\n" + error.response.data.message);
              $("#swap-button").html("Swap");
              $('#swap-button').prop('disabled', false);
            });
          }
        }
      }

      // trigger swapping 
      var smart_swap = function() {
        var amount = $("#amount-swap").val();
        var from_token = $("#swap-from").val();
        var words;

        if (from_token !== "ETH") {
          // case of IDEX
          words = "Swap has the same effect as withdraw for DAO deduction. ";
          var rate = (window.essentiaprice / window.daoprice).toFixed(2);
          var deduct = amount * rate;
          words = words + deduct.toString() + " DAO will be deducted.";
          swap_request_pattern(words, from_token, amount, "/api/idex/trade")
        } else {
          // case of radar relay
          words = "Are you sure to swap your Ether?";
          if ($("#ercdex-logo").hasClass( "active" )){
            swap_request_pattern(words, from_token, amount, "/api/ercdex/transact")
          } else if ($("#radar-logo").hasClass( "active" )){
            swap_request_pattern(words, from_token, amount, "/api/radarrelay/transact")
          } else if ($("#morph-logo").hasClass( "active" )){
            swap_request_pattern(words, from_token, amount, "/api/morph/transact")
          } else {
            PopUp.prototype.show("Error: \n Swap exchange unknown");
          }
        }
      }

    return (
      <div class="container">
        <div class="swappp">
            <div class="card-box" id="padding-side">

                <div class="align-center">
                    <img src={idex} id="idex-logo" class="dex_icon inline-dev active"/>
                    <img src={radar} onClick={to_radar} id="radar-logo" class="dex_icon inline-dev"/>
                    <img src={ercdex} onClick={to_ercdex} id="ercdex-logo" class="dex_icon inline-dev"/>
                    <img src={morph} id="morph-logo" class="dex_icon inline-dev"/>
                </div>

                <div>
                    <h5 class="price align-center">
                    <p>
                    Estimated Price: <span id="swapprice">0</span>
                    </p>
                    <p id="token-to-token-price">
                    Estimated Price For ETH to Your Target Token: <span id="swapprice2">0</span>
                    </p>
                    </h5>
                    
                </div>

                <div class="swap-bar m-b-0">

                  <div class="inline-div">

                    <div>
                      <div class="token-amount inline-div m-r-10">
                          <input type="text" class="form-control inline-div" id="amount-swap" placeholder="Amount" onChange={estimation}/>
                      </div>

                      <div class="token-select inline-div">
                          <select class="form-control inline-div" id="swap-from"  onChange={from_token_change}>
                              <option value="ESS">ESS</option>
                              <option value="ETH">ETH</option>
                          </select>
                      </div>
                    </div>

                    <div>
                        You currently have <span id="currently-have">{essentiabalance} ESS </span>
                    </div>


                  </div>

                    <p id="arrow" class="inline-div"><i class="fa fa-arrow-right fa-2x"></i></p>




                  <div class="inline-div">  

                    <div>
                      <div class="token-amount inline-div m-r-10">
                              <input type="text" class="form-control inline-div" id="estimated-swap" placeholder="Estimated amount" disabled/>
                      </div>
                      <div class="token-select inline-div">
                          <select id="swap-to" class="form-control inline-div" onChange={to_token_change}>
                          <option value="ETH">ETH</option>
                          <option value="XYO">XYO</option>
                          </select>
                      </div>

                    </div>

                     <div id="miniconversion-div">
                        <p>Minimum conversion: <span id="miniconversion">0</span> <span id="miniconversion-unit">ESS</span></p>
                    </div>
                  </div>
                </div>
                

                <div class="address-input m-t-30">
                 
                    <input type="text" class="form-control" id="receiving_address" placeholder="Type receiving address here"/>
                    <p id="convert-eth">
                      Convert Ethereum will automatically send to your DAO wallet address. 
                    </p>

                    <div id="otp-block">
                        <div class="form-group">
                            <input type="text" class="form-control" id="otp-sending" placeholder="OTP Code" />
                        </div>
                    </div>

                    <div class="m-t-10">More in <a href="/dashboard/notification">information</a>
                    </div>
                </div>


                <div class="row m-t-80 m-b-30">
                    <p>
                        <button id="swap-button" class= "btn-lg btn-blue" onClick={smart_swap}>Convert</button>
                    </p>
                </div>
          </div>
        </div>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/swapcenter.js